export default {
	"order.TheProductYouPurchasedCannotBeActivatedTemporarilyYouCanLogInToTheCallAppToManuallyActivateItOrContactCustomerServiceForHelp": "您購買的商品當前暫時無法被激活，您可登錄【叫叫】App中進行手動激活或聯繫客服提供幫助",
	"order.yourPurchases": "您購買的商品",
	"order.ItHasBeenActivatedPleaseEnterTheCallAppAsSoonAsPossibleToExperience": "已被激活，請盡快進入【叫叫】App中進行體驗",
	"order.ParameterError": "參數錯誤!",
	"order.courseIsActive": "課程激活中",
	"order.youHavePurchased": "您已購買的",
	"order.Product": "產品"
}